module.exports = __webpack_public_path__ + "img/EEF_RGB_UA_trnsp.0a043770.png";